/**
 * Group Intros context that must survive web sign-in.
 *
 * Add to PeopleiKnow, Sign in, and Create account on `/session/{token}`
 * stash the token. After password, MFA, magic link, email verify, or
 * Google, land back on that session. A new account still sees the
 * phone-apps step first, then returns here.
 */

export const PENDING_GROUP_TOKEN = 'pending_group_token';
export const PENDING_GROUP_INTENT = 'pending_group_intent';
export const PENDING_GROUP_PARTICIPANT = 'pending_group_participant';

const TOKEN_RE = /^[A-Za-z0-9_-]{8,64}$/;

function store() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function stashPendingGroup({ token, intent = 'return', participantId = '' }) {
  const s = store();
  if (!s || !token || !TOKEN_RE.test(token)) return;
  s.setItem(PENDING_GROUP_TOKEN, token);
  s.setItem(PENDING_GROUP_INTENT, intent === 'join' ? 'join' : 'return');
  if (participantId) s.setItem(PENDING_GROUP_PARTICIPANT, String(participantId));
  else s.removeItem(PENDING_GROUP_PARTICIPANT);
}

export function peekPendingGroup() {
  const s = store();
  if (!s) return null;
  const token = s.getItem(PENDING_GROUP_TOKEN);
  if (!token || !TOKEN_RE.test(token)) return null;
  return {
    token,
    intent: s.getItem(PENDING_GROUP_INTENT) === 'join' ? 'join' : 'return',
    participantId: s.getItem(PENDING_GROUP_PARTICIPANT) || '',
  };
}

export function groupContinuePath() {
  const pending = peekPendingGroup();
  return pending ? `/session/${pending.token}` : null;
}

export function consumePendingGroup(expectedToken) {
  const pending = peekPendingGroup();
  if (!pending) return null;
  if (expectedToken && pending.token !== expectedToken) return null;
  const s = store();
  if (s) {
    s.removeItem(PENDING_GROUP_TOKEN);
    s.removeItem(PENDING_GROUP_INTENT);
    s.removeItem(PENDING_GROUP_PARTICIPANT);
  }
  return pending;
}
